module.exports = __webpack_public_path__ + "media/images/tutorial_header_pc3-03-23fd0018bdccdc5343571d3f363e0f03.png";